import { render, staticRenderFns } from "./ArrowPlusDown.vue?vue&type=template&id=54a09d47&scoped=true&"
import script from "./ArrowPlusDown.vue?vue&type=script&lang=js&"
export * from "./ArrowPlusDown.vue?vue&type=script&lang=js&"
import style0 from "./ArrowPlusDown.vue?vue&type=style&index=0&id=54a09d47&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a09d47",
  null
  
)

export default component.exports